import React, { useState } from 'react';
import ImageWithSkeleton from '../components/ImageWithSkeleton';

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  // Gallery images categorized
  const galleryImages = {
    apartments: [],
    amenities: [
      {
        url: 'https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/r9a8jrn3_DJI_20250701170633_0284_D.jpg',
        alt: 'Aerial view of The Summit on King and surrounding mountains',
        category: 'amenities'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/ux9u68az_DJI_20250701170659_0286_D%202.jpg',
        alt: 'Aerial view of building complex from above',
        category: 'amenities'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/2sprma0j_DJI_20250701170829_0292_D.jpg',
        alt: 'Aerial view of The Summit on King at sunset',
        category: 'amenities'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/rvnrinum_DJI_20250701170838_0293_D.jpg',
        alt: 'Detailed aerial view of building layout',
        category: 'amenities'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/hyicyxwc_DJI_20250701170844_0294_D.jpg',
        alt: 'Stunning sunset aerial view of The Summit on King with mountain backdrop',
        category: 'amenities'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/s28es7ml_Downtown%20full%20campus%20view.jpg',
        alt: 'Aerial view showing proximity to Appalachian State University campus',
        category: 'amenities'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/1ao7dq9i_Homepage%20hero%20image.jpg',
        alt: 'Aerial view of The Summit on King buildings on King Street',
        category: 'amenities'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/klyuht9q_P6302511%202.jpg',
        alt: 'Exterior walkway with mountain sunset views',
        category: 'amenities'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/215jsqjx_P6302576%202.jpg',
        alt: 'Building entrance with on-site parking',
        category: 'amenities'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/tfdj9ykg_P6302596%202.jpg',
        alt: 'Exterior porch with views of surrounding buildings',
        category: 'amenities'
      }
    ]
  };

  // Combine all images for "All" filter
  const allImages = [...galleryImages.apartments, ...galleryImages.amenities];

  // Get filtered images
  const getFilteredImages = () => {
    if (activeFilter === 'all') return allImages;
    if (activeFilter === 'apartments') return galleryImages.apartments;
    if (activeFilter === 'amenities') return galleryImages.amenities;
    return [];
  };

  const filteredImages = getFilteredImages();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[450px] w-full overflow-hidden">
        <img
          src="https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/sfhzcmuz_Gallery%20hero%20image.jpg"
          alt="Modern kitchen with white and wood cabinets"
          className="absolute inset-0 w-full h-full object-cover grayscale-[30%] animate-scale-in"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-black/30">
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white tracking-widest animate-fade-in-up">GALLERY</h1>
        </div>
      </section>

      {/* Tour Your Home Section */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 animate-fade-in-up">
            TOUR YOUR <span className="text-[#FF5722]">HOME</span>
          </h2>
          <p className="text-lg md:text-xl text-black leading-relaxed mb-10 animate-fade-in-up animation-delay-100">
            The Summit on King offers a quiet retreat with mountain views in the heart of Boone — walkable to shops and dining and just steps from Appalachian State University. Explore spacious apartments with modern finishes and comfortable layouts designed for calm, comfortable living.
          </p>
          
          {/* Filter Tabs */}
          <div className="flex gap-2 md:gap-8 overflow-x-auto pb-2 md:pb-0 md:justify-center scrollbar-hide">
            <button
              onClick={() => setActiveFilter('all')}
              className={`whitespace-nowrap px-4 py-2 text-sm md:text-base font-semibold tracking-wide transition-colors ${
                activeFilter === 'all'
                  ? 'text-black border-b-2 border-[#FF5722]'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              ALL
            </button>
            <button
              onClick={() => setActiveFilter('amenities')}
              className={`whitespace-nowrap px-4 py-2 text-sm md:text-base font-semibold tracking-wide transition-colors ${
                activeFilter === 'amenities'
                  ? 'text-black border-b-2 border-[#FF5722]'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              AMENITIES
            </button>
            <button
              onClick={() => setActiveFilter('apartments')}
              className={`whitespace-nowrap px-4 py-2 text-sm md:text-base font-semibold tracking-wide transition-colors ${
                activeFilter === 'apartments'
                  ? 'text-black border-b-2 border-[#FF5722]'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              APARTMENTS
            </button>
            <button
              onClick={() => setActiveFilter('video-tours')}
              className={`whitespace-nowrap px-4 py-2 text-sm md:text-base font-semibold tracking-wide transition-colors ${
                activeFilter === 'video-tours'
                  ? 'text-black border-b-2 border-[#FF5722]'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              VIDEO TOURS
            </button>
          </div>
        </div>
      </section>

      {/* Gallery Grid Section */}
      <section className="pb-16 md:pb-24 bg-white">
        <div className="container mx-auto px-4">
          {/* Apartments Section */}
          {(activeFilter === 'all' || activeFilter === 'apartments') && (
            <div className="mb-12">
              <h3 className="text-xl font-semibold mb-6 text-gray-800">Apartments</h3>
              <div className="text-center py-12 bg-gray-50 rounded-lg">
                <p className="text-gray-600 text-lg mb-2">Apartment photos coming soon!</p>
                <p className="text-gray-500">Check back later for interior photos of our beautiful apartments.</p>
              </div>
            </div>
          )}

          {/* Amenities Section */}
          {(activeFilter === 'all' || activeFilter === 'amenities') && galleryImages.amenities.length > 0 && (
            <div className="mb-12">
              <h3 className="text-xl font-semibold mb-6 text-gray-800">Amenities</h3>
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {/* Large featured image */}
                  <button className="md:col-span-2 relative aspect-[4/3] md:aspect-[16/10] rounded-lg overflow-hidden cursor-pointer">
                    <img
                      src={galleryImages.amenities[0].url}
                      alt={galleryImages.amenities[0].alt}
                      className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </button>
                  {/* Two smaller images on the right */}
                  <div className="flex flex-col gap-4">
                    {galleryImages.amenities.slice(1, 3).map((image, index) => (
                      <button
                        key={index}
                        className="relative aspect-[4/3] rounded-lg overflow-hidden cursor-pointer"
                      >
                        <img
                          src={image.url}
                          alt={image.alt}
                          className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                        />
                      </button>
                    ))}
                  </div>
                </div>
                {/* Grid of remaining images */}
                {galleryImages.amenities.length > 3 && (
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {galleryImages.amenities.slice(3).map((image, index) => (
                      <button
                        key={index}
                        className="relative aspect-square rounded-lg overflow-hidden cursor-pointer"
                      >
                        <img
                          src={image.url}
                          alt={image.alt}
                          className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                        />
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Video Tours Section */}
          {activeFilter === 'video-tours' && (
            <div className="mb-12">
              <h3 className="text-xl font-semibold mb-6 text-gray-800">Video Tours</h3>
              <div className="text-center py-12 bg-gray-50 rounded-lg">
                <p className="text-gray-600 text-lg mb-2">Video tours coming soon!</p>
                <p className="text-gray-500">Virtual tours of our apartments will be available shortly.</p>
              </div>
            </div>
          )}
        </div>
      </section>

      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default Gallery;
